import { gql } from "graphql-request";

export const entity = {
  getEntities: gql`
    query GetEntities($isActive: Boolean, $isAssignedToProject: Boolean) {
      entities(isActive: $isActive, isAssignedToProject: $isAssignedToProject) {
        id
        name
      }
    }
  `,
};
